import React, { useCallback, useEffect, useState } from "react";
import TreeList, { Column, SearchPanel as TreeSearch, Selection } from "devextreme-react/tree-list";
import FontFa from "../../../../../components/fontFa/fontFa";
import DataGrid, {
  FilterRow,
  HeaderFilter,
  SearchPanel,
  Editing,
  Texts,
  Button as GirdButton,
  EmailRule,
  RequiredRule,
  Paging,
} from "devextreme-react/data-grid";
import { Button, Col, Modal, Row } from "react-bootstrap";
import _ from "lodash";
import { CreateNotification } from "../../../../../components/notifier";
import { Employee, EmployeeService } from "../../../../../services/department-viags/employee-viags.service";
import { MailService } from "../../../../../services/mail/mail.service";
import { mailRegexs } from "../../../../../constants/mailTemplateConstants";
import { useSelector } from "../../../../../store/store";
import { getEnv } from "../../../../../AppConfigs";
import { Icon } from "../../../../../modules/icon";
import DepartmentDescTooltip from "../../../../setting/departments/components/department-desc-tooltip";
import { useDepartments } from "../../../../setting/departments/hooks/use-departments";
import { useUser } from "../../../../../hook";
import moment from "moment";
import { DocumentService } from "../../../../../services/document/document.service";
import {
  IssueUserRequest,
  StatisticsEmployeeService,
  UpdateDocsUserType,
} from "../../../../../services/department-viags/statistics-employee.service";

// const removeLowerPermission = (roles: EmployeeRole[]): EmployeeRole[] => {
//   const emailMap = new Map<string, EmployeeRole>();

//   roles.forEach((role) => {
//     const existingRole = emailMap.get(role.employeeEmail);
//     if (!existingRole || (role.isEdit && !existingRole.isEdit)) {
//       emailMap.set(role.employeeEmail, role);
//     }
//   });

//   return Array.from(emailMap.values());
// }

export const DepartmentList = (props: any) => {
  const {
    id,
    listId,
    title,
    isFolder,
    linkProcess,
    onClose,
    isOpen,
    document,
    isPublishStatus,
    isAddMore,
    departmentId,
  } = props;
  const [selectedEmployee, setSelectedEmployee] = useState<any[]>([]);
  const [documenTitle, setDocumenTitle] = useState<any>([]);
  const [links, setLinks] = useState<any>([]);
  const [isChanged, setIsChanged] = useState<any>(false);
  const [userDelete] = useState<any>([]);
  const [deleteId] = useState(null as any);
  const [newUsers, setNewUsers] = useState<any>([]);
  const [isViewChecked, setIsViewChecked] = useState<any>(false);
  const [isEditChecked, setIsEditChecked] = useState<any>(false);
  const [employeeData, setEmployeeData] = useState<Employee[]>([]);
  // const [departmentList, setDepartmentList] = useState<Department[]>([]);
  const [userHasEmail, setUserHasEmail] = useState<Employee[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);
  const [isUpdateEmployee, setIsUpdateEmployee] = useState(false);
  const [allowUpdate, setAllowUpdate] = useState(false);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const detailUrl = getEnv("REACT_APP_DOCUMENT_DETAILS_URL");
  const { name, email } = useUser();
  // const [isLoading, setIsLoading] = useState(false);
  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);

  const { data: departmentList = [], isLoading: isDepartmentsLoading } = useDepartments(undefined, departmentId);

  const isLoading = isDepartmentsLoading;

  const handleNameRender = (e: any) => {
    return (
      <div
        style={{
          cursor: "pointer",
          padding: "4px",
          backgroundColor: selectedDepartment?.id === e.data.id ? "#bae6fd" : "",
        }}
      >
        <span className="mr-1 text-warning">
          {" "}
          <FontFa name="faBuilding" size={"xs"} />
        </span>
        <span style={{ display: "inline-block", marginRight: 4 }}>{e.data.name}</span>
        <DepartmentDescTooltip desc={e.data.infoExtras} />
      </div>
    );
  };

  //* New api get department from cabinbook domain
  // const getDepartment = async (departmentCode?: string) => {
  //   setIsLoading(true);
  //   const res = await DepartmentService.getDepartmentListV5();
  //   if (!res) return;
  //   // setDepartmentList(res);
  //   setIsLoading(false);
  // };
  //*

  //* New api get department from cabinbook domain
  const getEmployee = async (departmentId: string) => {
    const res = await EmployeeService.getEmployeeListV5(departmentId);
    if (!res) return [];
    return res;
  };
  //*

  const getEmployeeHasEmail = async () => {
    const res = await EmployeeService.getEmployeeListHasEmail();
    if (!res) return;
    setUserHasEmail(res);
  };

  const getIsView = (eEmail: string) => {
    if (!eEmail) return false;
    const isView = selectedEmployee.find((e: any) => e.employeeEmail?.toLowerCase() === eEmail);
    return isView?.isView || false;
  };

  const getIsEdit = (eEmail: string) => {
    if (!eEmail) return false;
    const employee = selectedEmployee.find((e: any) => e.employeeEmail?.toLowerCase() === eEmail);
    return employee?.isEdit ?? false;
  };

  const handleCellClick = async (e: any) => {
    setIsEmployeeLoading(true);
    setSelectedDepartment(e?.row?.data);
    const treeList = e.component;
    const targetRowKey = e.key;
    treeList.expandRow(targetRowKey);
    const departmentId = e?.row?.key;
    const employeeDepartmentData = await getEmployee(departmentId);

    if (employeeDepartmentData && employeeDepartmentData.length > 0) {
      employeeDepartmentData.forEach((e: any) => {
        e.isView = getIsView(e?.employeeEmail?.toLowerCase());
        e.isEdit = getIsEdit(e?.employeeEmail?.toLowerCase());
      });

      setEmployeeData(employeeDepartmentData);
    } else {
      setEmployeeData([]);
    }

    setIsEditChecked(false);
    setIsViewChecked(false);
    setIsEmployeeLoading(false);
  };

  // const handleCellClick = useCallback(
  //   async (keys: Key[]) => {
  //     setIsEmployeeLoading(true);
  //     setSelectedDepartment(keys);
  //     const departmentCode = keys[0] as string;

  //     const employeeDepartmentData = await getEmployee(departmentCode);
  //     if (employeeDepartmentData && employeeDepartmentData.length > 0) {
  //       employeeDepartmentData.forEach((e: any) => {
  //         e.isView = getIsView(e?.employeeEmail?.toLowerCase());
  //         e.isEdit = getIsEdit(e?.employeeEmail?.toLowerCase());
  //       });
  //       setEmployeeData(employeeDepartmentData);
  //     } else {
  //       setEmployeeData([]);
  //     }
  //     setIsEditChecked(false);
  //     setIsViewChecked(false);
  //     setIsEmployeeLoading(false);
  //   },
  //   [getIsEdit, getIsView],
  // );

  const updateRow = async (row: any) => {
    if (isUpdateEmployee) {
      const { isEdit, isView, acceptUpdate, ...fields } = row.data;
      const res = await EmployeeService.updateEmployee(fields);
      if (res.data) {
        CreateNotification({
          title: "Thành công",
          body: "Đã chỉnh sửa nhân sự thành công có mã " + fields.employeeCode,
          icon: "/icons/success.png",
        });
      } else {
        CreateNotification({ title: "Không thể thêm", body: "Email đã tồn tại", icon: "/icons/warning.png" });
      }
    } else {
      const index = selectedEmployee.findIndex(
        (e: any) => e.employeeEmail?.toLowerCase() === row.data.employeeEmail?.toLowerCase(),
      );
      if (index < 0) selectedEmployee.push(row.data);
      else {
        selectedEmployee[index] = { ...row.data };
      }
      setAllowUpdate(true);
    }
  };

  // const isRootFolder = (id: any) => {
  //   return !id || id === "root";
  // };

  // const addedShareLink = async (shareLink: IShareLinkInputData) => {
  //   try {
  //     const result = links;
  //     let link = result.find(
  //       (l: ISharepointLink) => l.link.type === shareLink.type && l.link.scope === shareLink.scope,
  //     );
  //     if (link) {
  //       if (shareLink.scope === SharePointScope.users) {
  //         const newUsers = shareLink?.users?.filter(
  //           (u: ISharepointUser) => !link?.users?.find((cu: ISharepointUser) => isEqualFromSharepointUsers(u, cu)),
  //         );
  //         if (newUsers && newUsers.length > 0) {
  //           const emails = newUsers.map((p: ISharepointUser) => p.email ?? "");
  //           setNewUsers(emails);
  //           let index = links.indexOf(link);
  //           try {
  //             if (isRootFolder(id)) {
  //               const links = await PermissionService.updateDocumentPermissons(
  //                 id,
  //                 emails,
  //                 [getRoleFromLinkType(shareLink.type)],
  //                 listId,
  //               );
  //               links.forEach((element: ISharepointLink) => {
  //                 result.push(element);
  //               });
  //             } else {
  //               var linkResult = await PermissionService.createSharedLink(
  //                 id,
  //                 isDocumentLibrary,
  //                 shareLink.scope,
  //                 shareLink.type,
  //                 emails,
  //                 listId,
  //               );
  //               if (index > -1) {
  //                 newUsers.forEach((element: ISharepointUser) => {
  //                   link?.users?.push(element);
  //                 });
  //                 result[index] = link;
  //               } else result.push(linkResult);
  //             }
  //           } catch (error) {
  //             console.log(error);
  //           }
  //           setIsChanged(true);
  //         }
  //       }
  //     } else {
  //       const emails =
  //         shareLink.scope === SharePointScope.users
  //           ? shareLink.users?.map((p: ISharepointUser) => p.email ?? "")
  //           : undefined;
  //       setNewUsers(emails);
  //       try {
  //         if (isRootFolder(id)) {
  //           const links = await PermissionService.updateDocumentPermissons(
  //             id,
  //             emails ?? [],
  //             [getRoleFromLinkType(shareLink.type)],
  //             listId,
  //           );
  //           links.forEach((element: ISharepointLink) => {
  //             result.push(element);
  //           });
  //         } else {
  //           link = await PermissionService.createSharedLink(
  //             id,
  //             isDocumentLibrary,
  //             shareLink.scope,
  //             shareLink.type,
  //             emails,
  //             listId,
  //           );
  //           result.push(link);
  //         }

  //         setIsChanged(true);
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //     setLinks(result);
  //     // updateLinkGroups();
  //   } catch (error: any) {
  //     CreateNotification({ title: "Không thể cập nhật phân quyền", body: error, icon: "/icons/error.png" });
  //     console.log(error);
  //   }
  // };

  const sendMail = async (userArr: any[]) => {
    let url = detailUrl + "/";
    if (isPublishStatus) {
      url += document?.docWorkingId + `?status=publish&fileId=${document?.id}&action=info&index="1"`;
    } else {
      url += document?.listItemId + `?fileId=${document?.id}&action=info&index="1"`;
    }
    const template = mailtemplates.find((m: any) => (isPublishStatus ? m.eMailType === "PPD" : m.eMailType === "GPD"));
    const subject = template.eSubject.replace("{0}", document?.Title || "");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", document?.Title || "")
      .replace(mailRegexs.one + ";", isPublishStatus ? document?.docPublicDepartment ?? "" : document.docCode ?? "")
      .replace(mailRegexs.two + ";", isPublishStatus ? document.docCode : document?.subInfo || "")
      .replace(mailRegexs.three + ";", document.docPublishViewVersion || "0")
      .replace(mailRegexs.four + ";", isPublishStatus ? document.docEditionVersion : name || "")
      .replace(
        mailRegexs.five + ";",
        isPublishStatus
          ? `${moment(document.createdDateTime).format("DD/MM/YYYY")} - ${
              !document?.expiredDate ? "" : moment(document?.expiredDate).format("DD/MM/YYYY")
            }`
          : email || "",
      )
      .replace(mailRegexs.six + ";", document?.subInfo || "")
      .replace(mailRegexs.seven + ";", document?.createdUser?.displayName || "")
      .replace(mailRegexs.eight + ";", "")
      .replace(mailRegexs.nine + ";", document?.createdUser?.email || "")
      .replace(mailRegexs.siteUrl, url);
    MailService.sendMailByBotit({ content, subject, toMail: userArr.map((e: any) => e.email).join(";") });

    // const message = MailService.buildMailMesssageForPeople(
    //   subject,
    //   content,
    //   "html",
    //   userArr.map((e: any) => e.employeeEmail),
    // );
    // await MailService.sendMail(message);
  };

  const onUpdatePermissionClick = async (userData: any) => {
    // const newLinkProcess = [
    //   ...new Set(
    //     linkProcess?.flatMap((e: any) =>
    //       e.users.map((user: any) => ({
    //         ...user,
    //         isView: e.roles.includes("read"),
    //         isEdit: e.roles.includes("write"),
    //       })),
    //     ),
    //   ),
    // ];

    // const listDiff = _.differenceWith(
    //   selectedEmployee,
    //   newLinkProcess,
    //   (a: any, b: any) => a.employeeEmail === b.email && a.isEdit === b.isEdit && a.isView === b.isView,
    // );
    // const listSendMail = listDiff.filter((e: any) => e.isView || e.isEdit);
    // const listRemove = listDiff.filter((e: any) => !e.isView && !e.isEdit);

    // const viewList: IShareLinkInputData = {
    //   scope: "users",
    //   type: "view",
    //   sendInvitation: true,
    //   users: listDiff
    //     .filter((e: any) => e.isView && !e.isEdit)
    //     .map((item: any) => ({
    //       id: "",
    //       displayName: item.employeeName,
    //       email: item.employeeEmail,
    //     })),
    // };

    // const editList: IShareLinkInputData = {
    //   scope: "users",
    //   type: "edit",
    //   users: listDiff
    //     .filter((e: any) => e.isEdit)
    //     .map((item: any) => ({
    //       id: "",
    //       displayName: item.employeeName,
    //       email: item.employeeEmail,
    //     })),
    // };

    // if (viewList.users.length > 0) addedShareLink(viewList);
    // if (editList.users.length > 0) addedShareLink(editList);
    // CreateNotification({
    //   title: "Cập nhật thành công",
    //   body: "Cập nhật phân quyền thành công",
    //   icon: "/icons/success.png",
    // });
    // if (listSendMail.length > 0) {
    //   sendMail(listSendMail.filter((e: any) => e.isView || e.isEdit));
    // }
    // if (listRemove.length > 0) {
    //   listRemove.forEach((e: any) => {
    //     if (isGUID(e.roleId)) {
    //       PermissionService.revokeSharedLink(id, true, e.roleId, e.employeeEmail, listId);
    //     } else {
    //       PermissionService.deleteDocumentPermission(id, e.roleId, listId, false);
    //     }
    //   });
    // }

    if (isPublishStatus) {
      const itemInfo: any = await DocumentService.getPublicDocumentInfoFromWorkingDocument(
        document.docWorkingId,
        listId,
      );

      if (itemInfo && selectedEmployee?.length > 0) {
        let userArr: any[] = itemInfo.docPublicEndUsers || [];

        const fileAssignedTo = itemInfo.fileAssignedTo ? JSON.parse(itemInfo.fileAssignedTo) : [];

        const diffAssigned = _.differenceWith(
          selectedEmployee,
          fileAssignedTo,
          (a: any, b: any) => a.employeeEmail === b.email,
        );

        const mappedAssigned: any[] = diffAssigned.map((x: any) => ({
          Claims: `i:0#.f|membership|${x.employeeEmail}`,
          Id: x.employeeCode || "",
          department: x.departmentName,
          departmentCode: x.departmentCode,
          pDeptCode: x.depList?.at(1)?.name_VN ?? "",
          departmentId: x.departmentId,
          displayName: x.employeeName || "",
          email: x.employeeEmail,
          jobTitle: x.position ?? "",
          isView: x.isView,
          isEdit: x.isEdit,
        }));

        const diffUser = _.differenceWith(selectedEmployee, userArr, (a: any, b: any) => a.employeeEmail === b.email);

        const newUser = diffUser.map((e: any) => {
          return {
            id: e.employeeCode,
            name: e.employeeName,
            email: e.employeeEmail,
            jobTitle: "",
          };
        });

        userArr.push(...newUser);

        if (mappedAssigned?.length > 0) {
          sendMail(mappedAssigned.filter((e: any) => e.isView || e.isEdit));
          const newFileAssigned = [...fileAssignedTo, ...mappedAssigned];

          const fields = {
            docPublicEndUsers: userArr.length > 0 ? JSON.stringify(userArr) : "",
            fileAssignedTo: newFileAssigned.length > 0 ? JSON.stringify(newFileAssigned) : null,
          };

          const userStatistic: IssueUserRequest[] = newFileAssigned.map((s) => ({
            departmentId: s.departmentId,
            departmentCode: s.departmentCode,
            departmentName: s.department,
            employeeCode: s.Id,
            employeeEmail: s.email,
          }));

          var statisticRequest: UpdateDocsUserType = {
            docId: itemInfo.listItemId,
            listIssusedUser: [...userStatistic],
          };

          await DocumentService.updatePulishFileInfo(itemInfo.id, fields);
          await StatisticsEmployeeService.updatePublishDocForUsers(statisticRequest);
        } else {
          const newFileAssigned = fileAssignedTo.map((e: any) => ({
            ...e,
            isEdit: selectedEmployee?.find((s: any) => s.employeeEmail === e.email).isEdit ?? e.isEdit,
            isView: selectedEmployee?.find((s: any) => s.employeeEmail === e.email).isView ?? e.isView,
          }));

          const fields = {
            docPublicEndUsers: userArr.length > 0 ? JSON.stringify(userArr) : "",
            fileAssignedTo: newFileAssigned.length > 0 ? JSON.stringify(newFileAssigned) : null,
          };
          await DocumentService.updatePulishFileInfo(itemInfo.id, fields);
        }

        CreateNotification({
          title: "Cập nhật thành công",
          body: "Cập nhật phân quyền thành công",
          icon: "/icons/success.png",
        });
      }
    }

    setAllowUpdate(false);
    closeForm();
  };

  const closeForm = () => {
    if (onClose) {
      if (links?.length > 0) {
        const linksArr = [...links];
        let newLinks = [];
        if (deleteId) {
          newLinks = linksArr.filter((e: any) => deleteId !== e.id);
          setIsChanged(true);
        } else if (userDelete.length > 0) {
          const index = linksArr.findIndex((e: any) => e.id === userDelete[0].id);
          const arrAfterDelete = userDelete.flatMap((e: any) => e.user);
          linksArr[index].users = [...arrAfterDelete];
          newLinks = [...linksArr];
          setIsChanged(true);
        }
        newLinks.length > 0 ? onClose(id, newLinks, isChanged, newUsers) : onClose(id, links, isChanged, newUsers);
      }
    }
  };

  const getEmployeeCode = useCallback(
    (user: any) => userHasEmail.find((e: any) => e.employeeEmail === user.email)?.employeeCode || "",
    [userHasEmail],
  );

  const getEmployeeName = useCallback(
    (user: any) => userHasEmail.find((e: any) => e.employeeEmail === user.email)?.employeeName || "",
    [userHasEmail],
  );

  const getSelectedEmployee = useCallback(async () => {
    // const userRead = linkProcess.flatMap((e: any) => {
    //   if (e.roles[0] === "read" || e.roles[0] === "write") {
    //     return e.users.map((user: any) => ({
    //       roleId: e.id,
    //       employeeCode: getEmployeeCode(user),
    //       employeeName: getEmployeeName(user),
    //       employeeEmail: user.email,
    //       isEdit: e.roles[0] === "write",
    //       isView: e.roles[0] === "read",
    //     }));
    //   }
    //   return [];
    // });

    if (document?.docWorkingId && isOpen) {
      const itemInfo: any = await DocumentService.getPublicDocumentInfoFromWorkingDocument(
        document.docWorkingId,
        listId,
      );

      if (itemInfo) {
        const fileAssignedTo = itemInfo.fileAssignedTo ? JSON.parse(itemInfo.fileAssignedTo) : [];

        const mappedEmployee = fileAssignedTo.map((e: any) => ({
          employeeCode: e.Id,
          employeeName: e.displayName,
          employeeEmail: e.email,
          isEdit: e.isEdit,
          isView: e.isView,
        }));
        setSelectedEmployee(mappedEmployee);
      }
    }

    // console.log(removeLowerPermission(userRead));
  }, [document?.docWorkingId, isOpen, listId]);

  const handleEditHeaderCheckboxChange = (e: any, cellInfo: any) => {
    const checked: any = e.target.checked;
    const rowData = employeeData;
    rowData.forEach((row: any) => {
      if (row.isEdit !== checked && row?.employeeEmail && row?.employeeEmail.toLowerCase().includes("@viags.vn")) {
        row.isEdit = checked;
        const checkedRow = { ...row, isEdit: checked };
        const selectedIndex = selectedEmployee.findIndex(
          (employee: any) => employee?.employeeEmail === row.employeeEmail,
        );
        if (selectedIndex > -1) selectedEmployee[selectedIndex] = { ...checkedRow };
        else selectedEmployee.push(checkedRow);
      } else return { ...e };
    });
    setIsEditChecked(checked);
    setEmployeeData(rowData);
    setAllowUpdate(true);
  };

  const handleViewHeaderCheckboxChange = (e: any, cellInfo: any) => {
    const checked: any = e.target.checked;
    const rowData = employeeData;
    rowData.forEach((row: any) => {
      if (row.isView !== checked && row?.employeeEmail && row?.employeeEmail?.toLowerCase().includes("@viags.vn")) {
        row.isView = checked;
        const checkedRow = { ...row, isView: checked };
        const selectedIndex = selectedEmployee.findIndex(
          (employee: any) => employee.employeeEmail === row.employeeEmail,
        );
        if (selectedIndex > -1) selectedEmployee[selectedIndex] = { ...checkedRow };
        else selectedEmployee.push(checkedRow);
      } else return { ...e };
    });
    setIsViewChecked(checked);
    setEmployeeData(rowData);
    setAllowUpdate(true);
  };

  const handleEditClick = () => {
    if (!selectedDepartment) {
      CreateNotification({
        title: "Không thể thêm",
        body: "Anh/Chị vui lòng chọn phòng ban trước",
        icon: "/icons/warning.png",
      });
      return;
    }
    setIsUpdateEmployee(!isUpdateEmployee);
  };

  const addNewRow = async (row: any) => {
    if (!row.data.employeeCode || !row.data.employeeName || !row.data.employeeEmail) {
      row.cancel = true;
      CreateNotification({
        title: "Không thể thêm",
        body: "Anh/Chị vui lòng nhập đầy đủ thông tin",
        icon: "/icons/warning.png",
      });
      return;
    } else if (!row.data.employeeEmail?.includes("@viags.vn")) {
      row.cancel = true;
      CreateNotification({ title: "Không thể thêm", body: "Email không hợp lệ", icon: "/icons/warning.png" });
      return;
    } else {
      const fields = {
        employeeCode: row.data.employeeCode,
        employeeName: row.data.employeeName,
        employeeEmail: row.data.employeeEmail,
        departmentCode: selectedDepartment.code,
        departmentName: selectedDepartment.name,
      };
      const res = await EmployeeService.addEmployee(fields);
      if (res.statusCode === 200) {
        CreateNotification({
          title: "Thêm thành công",
          body: "Thêm thành công nhân viên với mã nhân viên " + res.data,
          icon: "/icons/success.png",
        });
      }
    }
  };

  const removeRow = async (row: any) => {
    const fields = {
      employeeCode: row.data.employeeCode,
    };
    try {
      const res = await EmployeeService.deleteEmployee(fields);
      if (res.data)
        CreateNotification({
          title: "Xóa thành công",
          body: "Xóa thành công nhân sự có mã " + row.data.employeeCode,
          icon: "/icons/success.png",
        });
    } catch (error: any) {
      CreateNotification({ title: "Không thể xóa", body: error.message, icon: "/icons/warning.png" });
      console.log(error);
    }
  };

  const handleTextChange = async (e: any) => {
    const employeeDepartmentData = await getEmployee("1");
    if (employeeDepartmentData && employeeDepartmentData.length > 0) {
      employeeDepartmentData.forEach((e: any) => {
        e.isView = getIsView(e?.employeeEmail?.toLowerCase());
        e.isEdit = getIsEdit(e?.employeeEmail?.toLowerCase());
      });
      setEmployeeData(employeeDepartmentData);
    } else {
      setEmployeeData([]);
    }
  };

  const handleViewSelectedEmployee = () => {
    if (isAddMore) {
      const fileAssignedTo = document.fileAssignedTo ? JSON.parse(document.fileAssignedTo) : [];
      const mappedEmployee = fileAssignedTo.map((e: any) => ({
        employeeCode: e.Id,
        employeeName: e.displayName,
        employeeEmail: e.email,
        isEdit: e.isEdit,
        isView: e.isView,
      }));

      const res = [...mappedEmployee, ...selectedEmployee];

      setEmployeeData(res);
    } else {
      setEmployeeData(selectedEmployee);
    }
  };

  useEffect(() => {
    if (isAddMore) {
      setLinks(linkProcess);
      getSelectedEmployee();
    }

    const documentTitle = (isFolder ? "thư mục" : "") + ` '${title}'`;
    setDocumenTitle(documentTitle);

    if (isOpen) {
      // getDepartment();
      getEmployeeHasEmail();
    }
    setIsEditChecked(false);
    setIsViewChecked(false);

    setEmployeeData([]);
    setSelectedDepartment(null);
    setIsUpdateEmployee(false);
  }, [getSelectedEmployee, isAddMore, isFolder, isOpen, linkProcess, title]);

  return (
    <Modal show={isOpen} onHide={onClose} centered size="xl" className="" backdrop="static">
      <Modal.Header closeButton>
        <div>
          <Modal.Title>
            {!isPublishStatus ? `Phân quyền cho ${documenTitle}` : `Phân phối tài liệu ${documenTitle} đến`}
          </Modal.Title>
          {selectedDepartment && <div>🏢 {selectedDepartment.name}</div>}
        </div>
      </Modal.Header>
      <Modal.Body className="px-4 py-4" style={{ height: "700px" }}>
        <Row>
          {isLoading ? (
            <div className="tableLoading">
              <Icon.Loading />
            </div>
          ) : (
            <Col
              sm="3"
              md="3"
              style={{ maxHeight: "600px", overflow: "hidden", display: "flex", flexDirection: "column" }}
            >
              <TreeList
                id="Folder"
                dataSource={departmentList}
                showRowLines={false}
                showBorders={false}
                columnAutoWidth={true}
                allowColumnReordering={false}
                itemsExpr="viagsDepartmentChild"
                dataStructure="tree"
                expandNodesOnFiltering={false}
                autoExpandAll={false}
                onCellClick={handleCellClick}
                keyExpr="id"
                height="100%" // Ensures it fills the parent container
                style={{ flex: 1, overflow: "auto" }} // Allows internal scrolling
              >
                <Selection mode="single" key={selectedDepartment} />
                <TreeSearch visible={true} placeholder="Nhập tên phòng ban" width={200} />
                <Column
                  dataField="name"
                  caption="Phòng/Ban"
                  key="id"
                  cellRender={handleNameRender}
                  allowReordering={false}
                />
              </TreeList>
            </Col>
          )}

          {isEmployeeLoading || isLoading ? (
            <div className="tableLoading">
              <Icon.Loading />
            </div>
          ) : (
            <Col sm="9" md="9">
              <Button
                style={{
                  position: "absolute",
                  top: "4px",
                  left: "24px",
                  zIndex: "9999",
                }}
                variant="primary"
                onClick={() => handleViewSelectedEmployee()}
                hidden={!!departmentId}
              >
                Danh sách đã phân quyền
              </Button>
              <DataGrid
                id="employeeEmail"
                dataSource={employeeData}
                showRowLines={true}
                showBorders={true}
                columnAutoWidth={true}
                // keyExpr="employeeEmail"
                className="px-2"
                allowColumnReordering={false}
                allowColumnResizing={true}
                noDataText="Anh/Chị chưa chọn phòng ban hoặc phòng ban chưa có nhân sự nào"
                onRowUpdated={updateRow}
                onRowInserting={addNewRow}
                onRowRemoved={removeRow}
              >
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={10} />
                <FilterRow visible={true} applyFilter={true} />
                <SearchPanel
                  visible={true}
                  placeholder="Nhập tên nhân sự cần tìm"
                  width={300}
                  onTextChange={handleTextChange}
                />
                {/* <Toolbar>
                    <Item location="before">
                      <div className="informer">
                        <h2 className="count">state.totalCount</h2>
                      </div>
                    </Item>
                    <Item location="after">
                    </Item>                    
                  </Toolbar> */}
                <Editing
                  allowAdding={isUpdateEmployee}
                  allowDeleting={(e: any) => e.row.data.acceptUpdate && isUpdateEmployee}
                  allowUpdating={(e: any) =>
                    (e.row.data.employeeEmail &&
                      e.row.data.employeeEmail !== "0" &&
                      e.row.data.employeeEmail.toLowerCase().includes("@viags") &&
                      !isUpdateEmployee) ||
                    (isUpdateEmployee && e.row.data.acceptUpdate)
                  }
                  mode="cell"
                  refreshMode="reshape"
                >
                  <Texts confirmDeleteMessage="Anh/Chị có muốn xóa nhân sự này" confirmDeleteTitle="Thông báo" />
                </Editing>
                <Column
                  dataField="employeeCode"
                  caption="Mã nhân sự"
                  dataType="string"
                  allowEditing={isUpdateEmployee}
                  // width={120}
                  // cellRender={(e) => <p>{e.data.ID + ""}</p>}
                >
                  {isUpdateEmployee && <RequiredRule message="Anh/Chị vui lòng nhập mã nhân sự" />}
                </Column>
                <Column
                  dataField="employeeName"
                  caption="Tên nhân sự"
                  allowEditing={isUpdateEmployee}
                  // width={180}
                >
                  {isUpdateEmployee && <RequiredRule message="Anh/Chị vui lòng nhập tên nhân sự" />}
                </Column>
                <Column
                  dataField="employeeEmail"
                  caption="Email"
                  allowEditing={isUpdateEmployee}
                  allowResizing={true}
                  // width={200}
                  // visible={(e: any) => {return e.data.isUser}}
                >
                  <RequiredRule message="Anh/Chị vui lòng nhập mã email" />
                  <EmailRule message="Email không hợp lệ" />
                  {/* <PatternRule
                    message="Email phải bao gồm @viags.vn"
                    pattern={/^[a-zA-Z0-9._%+-]+@viags\.vn$/}
                  /> */}
                </Column>
                <Column
                  dataField="isView"
                  caption="Quyền xem"
                  dataType="boolean"
                  allowEditing={!isUpdateEmployee}
                  allowHeaderFiltering={false}
                  allowSorting={false}
                  visible={!isUpdateEmployee}
                  calculateDisplayValue={() => false}
                  headerCellRender={(cellInfo: any) => (
                    <>
                      <span>Quyền view </span>
                      <input
                        type="checkbox"
                        checked={isViewChecked}
                        onChange={(e) => handleViewHeaderCheckboxChange(e, cellInfo)}
                      />
                    </>
                  )}
                  width={180}
                  allowFixing={true}
                />
                <Column
                  dataField="isEdit"
                  caption="Quyền chỉnh sửa"
                  dataType="boolean"
                  allowEditing={!isUpdateEmployee}
                  allowHeaderFiltering={false}
                  allowSorting={false}
                  visible={!isUpdateEmployee}
                  calculateDisplayValue={() => false}
                  width={180}
                  allowFixing={true}
                  headerCellRender={(cellInfo: any) => (
                    <>
                      <span>Quyền Edit </span>
                      <input
                        type="checkbox"
                        checked={isEditChecked}
                        onChange={(e) => handleEditHeaderCheckboxChange(e, cellInfo)}
                      />
                    </>
                  )}
                />
                <Column type="buttons" visible={isUpdateEmployee}>
                  <GirdButton name="edit" icon="edit" hint="Chỉnh sửa nhân sự này" />
                  <GirdButton name="delete" icon="trash" hint="Xóa nhân sự này" />
                </Column>
              </DataGrid>
              {isUpdateEmployee && (
                <div>
                  <p className="px-2 py-2 text-danger">
                    *Khi thêm tài khoản dùng chung anh chị vui lòng bắt đầu với chuỗi kí tự "QLTL_Gr"
                  </p>
                </div>
              )}
            </Col>
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleEditClick} variant={isUpdateEmployee ? "success" : "warning"}>
          {isUpdateEmployee ? "Hoàn tất" : "Chỉnh sửa"}
        </Button>
        <Button onClick={onClose} variant="secondary" hidden={isUpdateEmployee}>
          Hủy
        </Button>
        <Button
          onClick={() => onUpdatePermissionClick(selectedEmployee)}
          variant={"info"}
          disabled={!allowUpdate}
          hidden={isUpdateEmployee}
        >
          Cập nhật
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
